// @ts-nocheck
/**
 * chat-analytics.js — Chat funnel analytics bridge for GTM/GA4.
 *
 * Emits lightweight dataLayer events aligned to the chat-first storefront flow.
 */
(function () {
  'use strict';

  window.AIFlorist = window.AIFlorist || {};

  var rootEl = null;
  var CUSTOM_EVENT_NAMES = {
    chat_message_sent: 'aiflorist:chat_message_sent',
    arrangement_generation_completed: 'aiflorist:arrangement_generation_completed',
    add_to_order: 'aiflorist:add_to_order',
    agent_price_reconciled: 'aiflorist:agent_price_reconciled',
    agent_tool_error_silent_retry: 'aiflorist:agent_tool_error_silent_retry',
    agent_structured_compaction_attempt: 'aiflorist:agent_structured_compaction_attempt',
    agent_structured_compaction_breaker_tripped: 'aiflorist:agent_structured_compaction_breaker_tripped',
  };
  var PIXEL_OWNED_EVENT_NAMES = {
    add_to_order: true,
  };

  function init(deps) {
    rootEl = (deps && deps.root) || document.getElementById('aiflorist-chat-root');
  }

  function publishCustomEvent(eventName, payload) {
    var customEventName = CUSTOM_EVENT_NAMES[eventName];
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!customEventName || !analytics || typeof analytics.publish !== 'function') return;
    try {
      analytics.publish(customEventName, payload || {});
    } catch (_err) {
      // Fail closed so storefront UX never depends on analytics transport.
    }
  }

  function push(eventName, payload) {
    var eventPayload = Object.assign(
      {
        event_source: 'fleur_chat',
        chat_surface: 'landing_chat',
        page_path: window.location.pathname,
      },
      payload || {}
    );
    if (!PIXEL_OWNED_EVENT_NAMES[eventName]) {
      var dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push(Object.assign({ event: eventName }, eventPayload));
    }
    publishCustomEvent(eventName, eventPayload);
  }

  function trackSessionStarted(hasExistingConversation) {
    push('chat_session_started', {
      has_existing_conversation: !!hasExistingConversation,
      customer_logged_in: rootEl ? rootEl.dataset.customerLoggedIn === 'true' : false,
    });
    var enhancedConversions = window.AIFlorist && window.AIFlorist.enhancedConversions;
    if (enhancedConversions && typeof enhancedConversions.applyToGoogleTag === 'function') {
      enhancedConversions.applyToGoogleTag();
    }
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', {
        send_to: 'AW-17969497006/Ai8qCI7doZIcEK6Hw_hC',
      });
    }
  }

  function trackMessageSent(config) {
    var safe = config || {};
    push('chat_message_sent', {
      interaction_source: safe.source || safe.interactionSource || 'chat_input',
      has_text: !!safe.hasText,
      has_image: !!safe.hasImage,
      reference_image_count: Number(safe.referenceImageCount || 0),
      has_conversation_id: !!safe.hasConversationId,
    });
  }

  function trackGenerationStarted(hasConversationId) {
    push('arrangement_generation_started', {
      has_conversation_id: !!hasConversationId,
    });
  }

  function trackGenerationCompleted(config) {
    var safe = config || {};
    push('arrangement_generation_completed', {
      has_image: !!safe.hasImage,
      has_wedding_concepts: !!safe.hasWeddingConcepts,
      has_price_breakdown: !!safe.hasPriceBreakdown,
      has_checkout_url: !!safe.hasCheckoutUrl,
    });
  }

  function trackImageGenerated(config) {
    var safe = config || {};
    push('image_generated', {
      has_price_breakdown: !!safe.hasPriceBreakdown,
      has_checkout_url: !!safe.hasCheckoutUrl,
      has_arrangement_name: !!safe.hasArrangementName,
    });
  }

  function trackWidgetOpened(config) {
    var safe = config || {};
    push('chat_widget_opened', {
      surface: safe.surface || 'landing_page',
      has_existing_conversation: !!safe.hasExistingConversation,
    });
  }

  function trackError(config) {
    var safe = config || {};
    push('chat_error', {
      error_type: safe.errorType || 'unknown',
      error_stage: safe.errorStage || 'unknown',
      has_conversation_id: !!safe.hasConversationId,
    });
  }

  function trackCheckoutLinkClicked(config) {
    var safe = config || {};
    push('checkout_link_clicked', {
      checkout_host: safe.checkoutHost || null,
      utm_source: safe.utmSource || null,
      utm_medium: safe.utmMedium || null,
      utm_campaign: safe.utmCampaign || null,
      utm_term: safe.utmTerm || null,
      utm_content: safe.utmContent || null,
      gclid: safe.gclid || null,
      gbraid: safe.gbraid || null,
      wbraid: safe.wbraid || null,
      fbclid: safe.fbclid || null,
      msclkid: safe.msclkid || null,
      ttclid: safe.ttclid || null,
      fbc: safe.fbc || null,
      fbp: safe.fbp || null,
      has_ga_cookie: !!safe.ga,
      has_gl_cookie: !!safe.gl,
    });
  }

  function trackAddToOrder(config) {
    var safe = config || {};
    var success = safe.success === true;
    push('add_to_order', {
      success: success ? 'true' : 'false',
      has_card_message: !!safe.hasCardMessage,
      has_selection_image: !!safe.hasSelectionImage,
      has_arrangement_name: !!safe.hasArrangementName,
      item_count: Number(safe.itemCount || 0),
      reason: success ? (safe.reason || 'success') : (safe.reason || 'unknown_failure'),
    });
  }

  function trackPriceReconciled(config) {
    var safe = config || {};
    push('agent_price_reconciled', {
      original: Number(safe.original || 0),
      corrected: Number(safe.corrected || 0),
      delta: Number(safe.delta || 0),
      placeholder: !!safe.placeholder,
    });
  }

  function trackToolErrorSilentRetry(config) {
    var safe = config || {};
    push('agent_tool_error_silent_retry', {
      tool_name: String(safe.toolName || ''),
      error_code: String(safe.errorCode || ''),
      attempts: Number(safe.attempts || 0),
      succeeded: !!safe.succeeded,
    });
  }

  function trackStructuredCompactionAttempt(config) {
    var safe = config || {};
    push('agent_structured_compaction_attempt', {
      attempted: !!safe.attempted,
      in_canary: !!safe.inCanary,
      result: String(safe.result || ''),
      source_messages: Number(safe.sourceMessages || 0),
      missing_tag_count: Number(safe.missingTagCount || 0),
      too_long: !!safe.tooLong,
    });
  }

  function trackStructuredCompactionBreakerTripped(config) {
    var safe = config || {};
    push('agent_structured_compaction_breaker_tripped', {
      consecutive_failures: Number(safe.consecutiveFailures || 0),
      result: String(safe.result || ''),
      source_messages: Number(safe.sourceMessages || 0),
    });
  }

  window.AIFlorist.analytics = {
    init: init,
    trackSessionStarted: trackSessionStarted,
    trackMessageSent: trackMessageSent,
    trackGenerationStarted: trackGenerationStarted,
    trackGenerationCompleted: trackGenerationCompleted,
    trackImageGenerated: trackImageGenerated,
    trackWidgetOpened: trackWidgetOpened,
    trackError: trackError,
    trackCheckoutLinkClicked: trackCheckoutLinkClicked,
    trackAddToOrder: trackAddToOrder,
    trackPriceReconciled: trackPriceReconciled,
    trackToolErrorSilentRetry: trackToolErrorSilentRetry,
    trackStructuredCompactionAttempt: trackStructuredCompactionAttempt,
    trackStructuredCompactionBreakerTripped: trackStructuredCompactionBreakerTripped,
  };
})();
